import React from 'react';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import EeClassesContent from 'components/ee-classes/EeClassesContent';
import EeClassesHeader from '../../components/ee-classes/EeClassesHeader/index';
import { createStyles } from '../../globalStyles';

const EeClassesPage = (): JSX.Element => {
  const classes = createStyles();

  return (
    <ProposalStatusLayout>
      <div className={classes.pageWrapper}>
        <EeClassesHeader />
        <EeClassesContent />
      </div>
    </ProposalStatusLayout>
  );
};

export default EeClassesPage;
